import { api } from './api';

export interface ZoneProfile {
  id: string;
  user_id: string;
  zone_id: string;
  discovered_name: string | null;
  display_name: string | null;
  max_sample_rate: number;
  max_bit_depth: number;
  dsd_capability: 'none' | 'dsd64' | 'dsd128' | 'dsd256';
  dsd_method: 'none' | 'dop' | 'native';
  is_prism_eligible: boolean;
  verified_at: string | null;
  verified_format: string | null;
  test_results: Record<string, { status: string; tested_at?: string }>;
  last_seen_at: string | null;
  sort_order: number;
  network_id: string | null;
  network_label: string | null;
  created_at: string;
  updated_at: string;
}

export const zoneService = {
  getProfiles: async (networkId?: string | null): Promise<{ zones: ZoneProfile[] }> => {
    const qs = networkId ? `?network_id=${encodeURIComponent(networkId)}` : '';
    return api.get(`/api/zones/profiles${qs}`);
  },

  updateProfile: async (
    zoneId: string,
    updates: Partial<Pick<ZoneProfile, 'display_name' | 'max_sample_rate' | 'max_bit_depth' | 'dsd_capability' | 'dsd_method' | 'verified_at' | 'verified_format' | 'test_results'>>,
  ): Promise<{ zone: ZoneProfile }> => {
    return api.put(`/api/zones/profiles/${encodeURIComponent(zoneId)}`, updates);
  },

  upsertProfile: async (
    zoneId: string,
    discoveredName: string,
    networkId?: string | null,
    networkLabel?: string | null,
  ): Promise<{ zone: ZoneProfile }> => {
    return api.post('/api/zones/profiles', {
      zone_id: zoneId,
      discovered_name: discoveredName,
      ...(networkId ? { network_id: networkId } : {}),
      ...(networkLabel ? { network_label: networkLabel } : {}),
    });
  },

  markSeen: async (zoneId: string, networkId?: string | null): Promise<{ ok: boolean }> => {
    return api.post(
      `/api/zones/profiles/${encodeURIComponent(zoneId)}/seen`,
      networkId ? { network_id: networkId } : {},
    );
  },

  deleteProfile: async (zoneId: string): Promise<{ ok: boolean }> => {
    return api.delete(`/api/zones/profiles/${encodeURIComponent(zoneId)}`);
  },

  reorderProfiles: async (zoneIds: string[]): Promise<{ ok: boolean }> => {
    return api.put('/api/zones/profiles/reorder', { zone_ids: zoneIds });
  },

  updateNetworkLabel: async (networkId: string, label: string): Promise<{ ok: boolean; updated: number }> => {
    return api.put('/api/zones/network-label', { network_id: networkId, label });
  },
};
